import { Link } from "react-router-dom";
import { INSTAGRAM, whatsappLink, PHONE_DISPLAY } from "../config";
import { Instagram, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ciruela text-crema pt-20 pb-10">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <p className="font-serif italic text-3xl">Lorena Cotano</p>
            <p className="font-sans text-xs tracking-[0.3em] uppercase text-ambar mt-2">
              Matrona · Sexóloga
            </p>
            <p className="font-body text-sm text-crema/70 mt-5 max-w-xs leading-relaxed">
              Acompañamiento integral a mujeres en embarazo, parto, puerperio y menopausia.
            </p>
          </div>

          <div>
            <p className="font-sans text-sm tracking-widest uppercase text-ambar mb-5">Instagram</p>
            <ul className="space-y-3">
              {INSTAGRAM.map((acc) => (
                <li key={acc.handle}>
                  <a
                    href={acc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-ig-${acc.handle.replace("@", "")}`}
                    className="inline-flex items-center gap-2 font-body text-sm text-crema/80 hover:text-ambar transition-colors"
                  >
                    <Instagram className="h-4 w-4" /> {acc.handle}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-sans text-sm tracking-widest uppercase text-ambar mb-5">Contacto</p>
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="inline-flex items-center gap-2 font-body text-sm text-crema/80 hover:text-ambar transition-colors"
            >
              <MessageCircle className="h-4 w-4" /> {PHONE_DISPLAY}
            </a>

            <p className="font-sans text-sm tracking-widest uppercase text-ambar mt-8 mb-5">Legal</p>
            <ul className="space-y-3 font-body text-sm">
              <li><Link to="/aviso-legal" data-testid="footer-aviso-legal" className="text-crema/80 hover:text-ambar transition-colors">Aviso legal</Link></li>
              <li><Link to="/politica-privacidad" data-testid="footer-privacidad" className="text-crema/80 hover:text-ambar transition-colors">Política de privacidad</Link></li>
              <li><Link to="/politica-cookies" data-testid="footer-cookies" className="text-crema/80 hover:text-ambar transition-colors">Política de cookies</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-crema/15 mt-16 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-crema/60">
            © {new Date().getFullYear()} Lorena Cotano · Matrona Sexóloga. Todos los derechos reservados.
          </p>
          <p className="font-body text-xs text-crema/40">Hecho con cuidado para acompañarte 💜</p>
        </div>
      </div>
    </footer>
  );
}
